import { axiosInstance } from '../../utils'
import type { LarkUser } from './types'

export * from './types'

const baseURL = '/api/notify'

export function listLarkUser(key: string): Promise<LarkUser[]> {
  return axiosInstance.get(`/organization/alluser?key=${key}`, {
    baseURL,
  })
}
